import { NavLink } from "react-router-dom";

type Props = {
  /** "dark" for use on light backgrounds (default); "light" for dark surfaces (footer, login panel) */
  tone?: "dark" | "light";
  className?: string;
};

/**
 * Wander NA brand mark: teal circle + lime triangle, followed by "WANDER·NA"
 * in tracked 800-weight caps. Pure CSS/SVG — no image asset required.
 */
const Logo = ({ tone = "dark", className = "" }: Props) => {
  const wordColor = tone === "light" ? "text-white" : "text-ink";
  return (
    <NavLink
      to="/"
      className={`flex items-center gap-[11px] no-underline ${className}`}
    >
      <span className="flex h-[30px] w-[30px] items-center justify-center rounded-full bg-secondary-400">
        <span
          className="h-3 w-3 bg-primary-500"
          style={{ clipPath: "polygon(50% 0, 100% 100%, 0 100%)" }}
        />
      </span>
      <span className={`text-[15px] font-extrabold tracking-[0.16em] ${wordColor}`}>
        WANDER<span className="text-secondary-400">·NA</span>
      </span>
    </NavLink>
  );
};

export default Logo;
